<template>
    <div class="sidebar-item">
        <transition name="pricing-section">
            <div v-if="Object.keys(productPricing).length > 0" class="sidebar-pricing-listing">
                <div v-for="price in productPricing" class="clearfix channel-item">
                    <div class="channel-name">{{price.name}}</div>
                    <div v-if="price.sell_price > 0" class="price">{{price.sell_price}}</div>
                    <div v-else class="price">N/A</div>
                </div>
                <router-link
                 class="sidebar-pricing-listing-see-more"
                 id="pricing-tab"
                 exact
                 :to="{name: 'pricing'}"
                 >
                 See More
                 </router-link>
            </div>
            <div v-else class="sidebar-pricing-listing">
                 <div class="no-price-found">
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i> No Price Set
                 </div>
                 <router-link
                 class="sidebar-pricing-listing-see-more"
                 id="pricing-tab"
                 exact
                 :to="{name: 'pricing'}"
                 >
                 Add a Price Record
                 </router-link>
            </div>
        </transition>
    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';

    Vue.use(VueEvents)

    export default {
        name: 'product-pricing',
        props: ['productPricing'],
        components:{
        },
        data() {
            return {
                uiStates: {
                    showSelect: false,
                },
            }
        },
        methods :{
        }
    };
</script>

<style scoped lang="scss">
    .pricing-section-enter-active, .pricing-section-leave-active {
      transition: opacity .5s;
    }
    .pricing-section-enter, .pricing-section-leave-to {
      opacity: 0;
    }
</style>